import type { SVGProps } from 'react'
const SvgBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="badge_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#badge_svg__a)">
      <path d="M3.054 16.652q-.708 0-1.208-.498a1.64 1.64 0 0 1-.498-1.208V6.804q0-.708.498-1.208a1.65 1.65 0 0 1 1.208-.498h3.544V2.955q0-.682.463-1.144.462-.464 1.144-.463h1.59q.681 0 1.144.463.464.463.463 1.144v2.143h3.544q.708 0 1.208.498.498.5.498 1.208v8.142q0 .709-.498 1.208a1.65 1.65 0 0 1-1.208.498zm0-1.706h11.892V6.804h-3.553q-.021.627-.496 1.064-.475.436-1.102.436h-1.59q-.627 0-1.102-.436a1.47 1.47 0 0 1-.497-1.064H3.054zM4.5 13.554H9v-.338q0-.319-.178-.59a1.2 1.2 0 0 0-.497-.422 4 4 0 0 0-.76-.253 3.8 3.8 0 0 0-.815-.085q-.432 0-.816.085-.384.084-.759.253-.319.15-.497.422a1.06 1.06 0 0 0-.178.59zm6-1.125h3v-1.125h-3zm-3.75-1.125q.468 0 .797-.328.328-.33.328-.797 0-.469-.328-.797a1.09 1.09 0 0 0-.797-.328q-.469 0-.797.328a1.09 1.09 0 0 0-.328.797q0 .468.328.797.328.328.797.328m3.75-1.125h3V9.054h-3zM8.259 6.642H9.74V3.01H8.259z" />
    </g>
  </svg>
)
export default SvgBadge
